import { app } from '../../../../../app';
import { Controller } from './main.controller';

app.component('userProfileMain', {
    bindings: {
        profile: '<',
        profiles: '<',
    },
    controller: Controller,
    templateUrl: require('./main.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/profiles/profile/main/main.component.js